import { render, staticRenderFns } from "./form-table.vue?vue&type=template&id=1237c646&scoped=true"
import script from "./form-table.vue?vue&type=script&lang=js"
export * from "./form-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1237c646",
  null
  
)

export default component.exports